import { Link } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';

import { IContactGroup } from 'contacts/types';
import { getAgGridTableCellData, getNestedValue } from 'core/utils';

interface IProps extends ICellRendererParams {
  colId?: string;
  openDetails: (data: IContactGroup) => void;
}

export const ContactGroupNameCell = ({ colId = 'name', openDetails, ...props }: IProps) => {
  const data = getAgGridTableCellData(props, colId);

  if (!data) {
    return props?.value;
  }

  return (
    <Link onClick={() => openDetails(data)} sx={{ textWrap: 'wrap' }}>
      {getNestedValue(data, colId)}
    </Link>
  );
};
